export default {
  "dbi-mobile-device-title": "Mobile Device",
  "dbi-mobile-device-overview-title": "Mobile Device Global Overview",
  "dbi-mobile-device-stats-title": "Mobile Device Data",
  "dbi-mobile-device-year": "Year",
  "dbi-mobile-device-month": "Month",
  "dbi-mobile-device-number": "Global Device Numbers",
  "dbi-mobile-device-number-atthened-1": "Global Device Numbers at the end of ",
  "dbi-mobile-device-number-atthened-2": " ",
  "dbi-mobile-device-top5Models": "Top 5 Models by Active Device in {time}",
  "dbi-mobile-device-top5Models-1": "Top 5 Models by Active Users at ",
  "dbi-mobile-device-top5Models-2": " ",
  "dbi-mobile-device-RAM-distribution": "RAM Distribution",
  "dbi-mobile-device-top-system-chips": "Top System Chips",
  "dbi-mobile-device-tiers-map": "Mobile phone distribution details based on Ram and chips",
  "dbi-mobile-device-tier": "Tier",
  "dbi-mobile-device-active-device": 'Active Device',
  "dbi-mobile-device-country": 'Country',
  "dbi-mobile-device-download-success": "Download successfully.",
  "dbi-mobile-device-download-full-data": "Download latest data",
  "dbi-mobile-device-Top-500-mobile-models": "Monthly data of mobile models",
  "dbi-mobile-device-download-loading": "loading...",
  "dbi-mobile-device-info-intro": "IEG Global set tiers for mobile devices based on RAM and Chips.",
  "dbi-mobile-device-android": "Android",
  "dbi-mobile-device-PnO-map": "Mobile phone distribution map",
  "dbi-mobile-device-modal_line_header": "Baseline for Android Device Model",
  "dbi-mobile-device-modal_line_header_ios": "Baseline for IOS Device Model",
  "dbi-mobile-device-stall": "Tier",
  "dbi-mobile-device-baseline_grading": "Baseline for Chip Grading",
  "dbi-mobile-device-user_share": "User share (Global)",
  "dbi-mobile-device-remarks": "Remarks",
  "dbi-mobile-device-tier-ram-chips": "Tier{num} Ram and chips",
  "dbi-mobile-device-ofdevice": "% of Device",
  "dbi-mobile-device-number-device": "Number of Device",
  "dbi-mobile-device-download_info": "You can download complete monthly device data from the Mobile Device-Overview page.",
  "dbi-mobile-device-download_info_btn": "Download the latest data for all countries counted"
}